/**
 * LeadsResponseCockpit — Response lens body for the Leads surface.
 *
 * Renders PipelineIntelligence inside the canonical cockpit shell with title
 * "Leads · {Section}". Section is read from `?section=` (synced by
 * PipelineIntelligence) so the masthead reflects the active sibling, matching
 * the hierarchy convention used by Install and Resolve.
 */
import { useSearchParams } from "react-router-dom";
import { CockpitPage } from "@/components/cockpit/CockpitPage";
import PipelineIntelligence from "@/pages/PipelineIntelligence";
const SECTION_LABEL: Record<string, string> = {
  command: "Command",
  sources: "Strategy",
  flows: "Execution",
  ai: "AI Control",
  autopilot: "Auto Pilot",
};

export default function LeadsResponseCockpit({
  lensControls,
}: { lensControls?: React.ReactNode }) {
  const [params] = useSearchParams();
  const section = params.get("section") ?? "command";
  const titleSuffix = SECTION_LABEL[section] ?? "Command";

  return (
    <CockpitPage title="Leads" titleSuffix={titleSuffix} controls={lensControls}>
      <PipelineIntelligence />
    </CockpitPage>
  );
}
